import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TooltipModule } from 'primeng/tooltip';

import { CallPipe } from '../../../pipes/call.pipe';
import { castIcon } from '../../../utils/cast';
import { wpPriorityMediumIcon } from 'src/app/svg/wp-priority-medium';

@Component({
  selector: 'app-wp-priority-badge',
  templateUrl: './wp-priority-badge.component.html',
  styleUrls: ['./wp-priority-badge.component.scss'],
  standalone: true,
  imports: [CallPipe, NgClass, NgIf, NgStyle, SvgIconComponent, TooltipModule],
})
export class WPPriorityBadgeComponent {
  @Input({ required: true }) wpPriority!: { name: string; color: string; icon?: string };
  @Input() labelClasses: string = ' text-xs';
  @Input() showLabel: boolean = true;
  @Input() showTooltip: boolean = true;
  readonly castIcon = castIcon;

  readonly defaultIcon = wpPriorityMediumIcon.name;
}
